"use strict";

angular.module("imagetrend.components").directive("hlpFormComponent", [
    "$compile",
    "$templateCache",
    "$filter",
    function($compile, $templateCache, $filter) {
        return {
            restrict: "AE",
            scope: {
                component: "=?",
                parentGroup: "=?",
                initializeAnswers: "&",
                parameters: "=?",
                resultSet: "=?",
                deficiencies: "=?",
                pdf: "=?",
                datapointAnswers: "=?",
                completed: "=?",
                saving: "=?",
                deficiencyScore: "=?",
                inspectionChecklist: "=?"
            },
            replace: true,
            transclude: true,
            //templateUrl: 'templates/form-builder-form/form-component/form-component.html',
            link: function (scope, elem, attrs, ctrl) {
                scope.initComponent = function (component) {
                    component.parameters = angular.copy(scope.parameters);
                    if (component.parameters != null) {
                        component.parameters.limit_document_type_ids =
                            component.limit_document_type_ids;
                        component.parameters.show_documents_without_type =
                            component.show_documents_without_type;
                        component.parameters.limit_position_ids =
                            component.limit_position_ids;
                        component.parameters.service_classification_filter_ids =
                            component.service_classification_filter_ids;
                        component.parameters.limit_vehicle_type_ids =
                            component.limit_vehicle_type_ids;
                        component.parameters.show_vehicles_without_type =
                            component.show_vehicles_without_type;
                        component.parameters.skill_question_ids =
                            component.skill_question_ids;
                        component.parameters.skill_show_points =
                            component.skill_show_points;
                        component.parameters.skill_default =
                            component.skill_default;

                        if (component.license_category_id != null) {
                            if (
                                component.parameters.orignalLicenseID == null &&
                                component.parameters.license_id != null
                            ) {
                                component.parameters.orignalLicenseID =
                                    component.parameters.license_id;
                            }

                            component.parameters.license_category_id =
                                component.license_category_id;

                            if (
                                component.parameters
                                    .default_license_category_id ==
                                component.license_category_id
                            ) {
                                component.parameters.license_id =
                                    component.parameters.orignalLicenseID;
                            } else {
                                component.parameters.license_id = null;
                            }
                        }
                    }
                };
                elem.append(
                    $compile(
                        $templateCache.get(
                            "templates/form-builder-form/form-component/form-component.html"
                        )
                    )(scope)
                );

                scope.$on("$destroy", function() {
                    if (elem) {
                        angular.element(elem).off(); // deregister all event handlers
                        angular.element(elem).remove();
                        elem = null;
                    }
                });

                scope.$watch("parentGroup.parameters.limit_document_type_ids", function (limit_document_type_ids) {
                    if (limit_document_type_ids != null) {
                        if (scope.component && scope.component.parameters) {
                            scope.component.parameters.limit_document_type_ids = limit_document_type_ids;
                        }
                    }
                });

                scope.$watch("parentGroup.parameters.show_documents_without_type", function (show_documents_without_type) {
                    if (show_documents_without_type != null) {
                        if (scope.component && scope.component.parameters) {
                            scope.component.parameters.show_documents_without_type = show_documents_without_type;
                        }
                    }
                });

                scope.$watch("parentGroup.parameters.limit_vehicle_type_ids", function (limit_vehicle_type_ids) {
                    if (limit_vehicle_type_ids != null) {
                        if (scope.component && scope.component.parameters) {
                            scope.component.parameters.limit_vehicle_type_ids = limit_vehicle_type_ids;
                        }
                    }
                });

                scope.$watch("parentGroup.parameters.show_vehicles_without_type", function (show_vehicles_without_type) {
                    if (show_vehicles_without_type != null) {
                        if (scope.component && scope.component.parameters) {
                            scope.component.parameters.show_vehicles_without_type = show_vehicles_without_type;
                        }
                    }
                });
            }
        };
    }
]);
